import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, Space, Table, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import usePackageTypeAPI from '../../apis/packageTypeAPI';
import EventEmitter from '../../../utils/eventEmitter';


const PackageTypeChanges = () => {
  const packageType = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState(packageType.name ? packageType.name : '');
  const { create, update } = usePackageTypeAPI();
  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['width'] = data.size.width;
    data['height'] = data.size.height;
    data['length'] = data.size.length;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    delete data['size'];
    create(data, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    update(packageType.seo, data, success);
    // console.log(data)
  };

  const handleDiscard = () => { };


  useEffect(() => {
    EventEmitter.subscribe('package_type_created', data => {
      navigate('/inventory/package-types/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('package_type_created');
    }
    
  },[])
  
  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/inventory/package-types'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Package Types</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              // disabled={ formValue.status === 'discard'? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {packageType.seo && <Button onClick={edit}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          name='routechanges'
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Packaging Type Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={{size: {height: 0, width: 0, length:0}}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row className='mt-5'>
            <Col md={{ span: 11 }}>
              <Form.Item label='Size' className='font-semibold mb-2' required >
                <Space.Compact>
                  <Form.Item name={['size', 'height']} noStyle>
                    <InputNumber className='input-outline-none font-normal' name='height' addonAfter='x' />
                  </Form.Item>
                  <Form.Item name={['size', 'width']} noStyle>
                    <InputNumber className='input-outline-none font-normal' name='width' addonAfter='x'/>
                  </Form.Item>
                  <Form.Item name={['size', 'length']} noStyle>
                    <InputNumber className='input-outline-none font-normal' name='length' />
                  </Form.Item>
                </Space.Compact>
              </Form.Item>
              <Form.Item label='Weight' name={'weight'} className='font-semibold text-gray-800 mb-4' required>
                <InputNumber className='input-outline-none font-normal w-full' addonAfter={'kg'}/>
              </Form.Item>
              <Form.Item label='Max Weight' name={'max_weight'} className='font-semibold text-gray-800 mb-4' required>
                <InputNumber className='input-outline-none font-normal w-full' addonAfter={'kg'}/>
              </Form.Item>
            </Col>
            <Col md={{ span: 10, offset: 1 }}>
              <Form.Item labelCol={{span: 10}} label='Carrier' name={'carrier'} className='font-semibold text-gray-800 mb-4' required>
                <Input className='input-outline-none font-normal'/>  
              </Form.Item>
              <Form.Item labelCol={{span: 10}} label='Carrier Code' name={'carrier_code'} className='font-semibold text-gray-800 mb-4' required>
                <Input className='input-outline-none font-normal'/>  
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default PackageTypeChanges;